import { Ti18nKeys } from "./i18n";

export type TI18nInpt =
  | 308
  | 3001
  | 3002
  | 3003
  | 3004
  | 3005
  | 3006
  | 3008
  | 3009
  | 3010
  | 3012
  | 3014
  | 3015
  | 3016
  | 3017
  | 3018
  | 3019
  | 3020
  | 3022
  | 3023
  | 3024
  | 3025
  | 3026
  | 3027
  | 3028
  | 3029
  | 3030
  | 3032
  | 3033
  | 3034
  | 3035
  | 3036
  | 3037
  | 3038
  | 3039
  | 3040
  | 3041
  | 3043
  | 3044
  | 3045
  | 3046
  | 3047
  | 3048
  | 3049
  | 3050
  | 3051
  | 3052
  | 3056
  | 3057
  | 3065
  | 3067
  | 3068
  | 3069
  | 3072
  | 3073
  | 3074
  | 3075
  | 3076
  | 3077
  | 3080
  | 3081
  | 3082
  | 3083
  | 3084
  | 3085
  | 3086
  | 3087
  | 3088
  | 3089
  | 3090
  | 3091
  | 3092
  | 3093
  | 3094
  | 3095
  | 3096
  | 3097
  | 3098
  | 3099
  | 3103
  | 3104
  | 3105
  | 3107
  | 3109
  | 3110
  | 3112
  | 3113
  | 3114
  | 0;

export type TI18n = {
  LG: { [key in string]: Ti18nKeys };
  get: (message: TI18nInpt) => Ti18nKeys;
};

const i18nServerResponse: TI18n = {
  LG: {
    0: "ET3ERROR",
    308: "ROUTE_NOT_DEFINED",
    3001: "INVALID_MISSING_ID_TYPE_NUMBER",
    3002: "INVALID_PASSWORD_NUM",
    3003: "INVALID_USER_ID",
    3004: "INVALID_PLATFORM",
    3005: "INVALID_CREDENTIALS_NUM",
    3006: "INVALID_INPUT",
    3008: "INVALID_STATUS",
    3009: "INVALID_TIME_FRAME",
    3010: "INVALID_COUNTRY",
    3012: "REPORTS_NOT_FOUND",
    3014: "NO_RESULT",
    3015: "SERVER_ERROR_SHOWING_CONTACT",
    3016: "USER_NOT_FOUND",
    3017: "ADMIN_ID_REQUIRED",
    3018: "ADMIN_NOT_FOUND",
    3019: "NO_PERMISSION",
    3020: "DEVICE_NOT_FOUND",
    3022: "USER_LOGIN_NOT_FOUND",
    3023: "PAYMENTS_NOT_FOUND",
    3024: "TRANSACTION_NOT_FOUND",
    3025: "MESSAGES_NOT_FOUND",
    3026: "CONVERSATION_NOT_FOUND",
    3027: "INCORRECT_PASSWORD",
    3028: "NO_APPROVAL_DATA",
    3029: "SOMETHING_WRONG",
    3030: "CANNOT_CHANGE_STATUS_TO_ACTIVE",
    3032: "WRONGKEY",
    3033: "WRONGBODYCOUNT",
    3034: "REFERRAL_CODE_NOT_FOUND",
    3035: "INVALID_TOKEN",
    3036: "INVALID_USER_NAME",
    3037: "PLEASE_SHARE_FACEBOOK",
    3038: "PLEASE_SHARE_NUMBER",
    3039: "PLEASE_SHARE_DATA_TABLE",
    3040: "PLEASE_SHARE_USERS_TABLE",
    3041: "PLEASE_SHARE_APPLE_ID",
    3043: "USER_SEARCH_TYPE_REQUIRED",
    3044: "INVESTIGATION_CASES_NOT_FOUND",
    3045: "ACCOUNTS_DELETION_DATA_NOT_FOUND",
    3046: "EMPTY_COMMENT",

    3048: "USER_ALREADY_UNDER_CSR_INVESTIGATION",
    3049: "REPORT_NOT_FOUND",
    3050: "DESCRIPTION_ACTION_ALREADY_DONE",
    3051: "PEER_DESCRIPTION_ACTION_ALREADY_DONE",
    3052: "PICTURE_ACTION_ALREADY_DONE",
    3056: "DESCRIPTION_CHANGED",
    3057: "INVESTIGATION_CASE_ALREADY_RESOLVED",
    3063: "NO_CLEAN_POOL_DATA",
    3064: "NO_MORE_MESSAGES",
    3065: "INCORRECT_CLIENT_ID",
    3067: "ONE_O_TWO_CLIENT_MATCH_SAME_GENDER",
    3068: "NOT_UPDATED_CHECK_IF_CORRECT_PAYEMTN_INTENT",
    3069: "NOT_UPDATED_CHECK_IF_CORRECT_SUBSCRIPTION",
    3072: "USER_DOES_NOT_EXIST_OR_INACTIVE",
    3073: "ONE_O_TWO_CONVERSATION_ALREADY_CREATED",
    3074: "ONE_O_TWO_CONVERSATION_IS_NOT_ACTIVE_ANYMORE",
    3077: "NO_RECEIPT_TOKEN_FOUND",
    3080: "CANNOT_CHANGE_TO_SAME_STATUS",
    3081: "NO_WEB_USER_PAYMENT_ARCHIVE_DATA",
    3082: "WRONG_REFFERAL_CODE",
    3083: "ADMIN_USERS_HAVE_ALREADY_ANOTHER_ACTIVE_POOL",
    3084: "RECEIPT_FOUND_FOR_THIS_MONTH",
    3085: "SUBMIT_DATE_IS_SPECIFIC",
    3086: "IMAGE_STATUS_DELETED",
    3087: "NO_MATCHES_FOUND",
    3088: "NO_CITIES_FOUND",
    3089: "NO_APPROVED_MATCHES_FOUND",
    3090: "NO_PAID_USERS_FOUND",
    3091: "NO_LONGER_ACTIVE_POOL",
    3093: "WRONG_PROFILE_ID",
    3094: "PROFILE_ID_NOT_FOUND",
    3095: "REPORT_CASE_EXISTS_IN_SOME_POOL",
    3096: "REPORT_CASES_ALREADY_RESOLVED",
    3097: "THERE_IS_ANOTHER_AVAILABLE_KHATTABA",
    3099: "NO_KHATTABAT_ADMIN",
    3100: "USER_SHOULD_BE_VERIFIED",
    3101: "USER_IS_NOT_MALE_USER",
    3102: "USER_NEVER_PAYING_KHATTABAT",
    3103: "USER_IS_NOT_MATCHED_TO_THIS_KHATTABA",
    3104: "LIMIT_REACHED_KHATTABA_CLIENTS",
    3105: "NO_NEW_CLIENTS_AVAILABLE",
    3107: "KHATTABA_V3_IS_ALREADY_TURNED_OFF",
    3109: "NO_AI_APPLICATIONS_FOUND",
    3110: "INVALID_AGE",
    3111: "KHATTABA_V3_AI_IS_ALREADY_TURNED_OFF",
    3112: "APP_VERSION_BELOW_NINE_POINT_FIVE",
    3113: "CLIENT_ALREADY_ASSIGNED_TO_ANOTHER_KHATTABA",
    3114: "ONE_O_TWO_MATCH_IS_IN_ANOTHER_ONGOING_ONE_O_TWO"
  },
  get(message) {
    return this.LG[message] === undefined || this.LG[message] === undefined
      ? `${message}`
      : this.LG[message];
  }
};

export default i18nServerResponse;
